module.exports = __webpack_public_path__ + "img/134.9.bcbb2116.png";